export default {
	title: 'defaultTitle',
};

export const languagesHebrew = {
	he: 'עברית',
	en: 'אנגלית',
};
